<template>
  <div class="menu_component" :class="[collapsed ? 'width80' : 'width180']">
    <!--    <div class="menu_component-wrap">-->
    <!--    -->
    <!--    </div>-->


    <div class="logo">
      <img src="http://usdb.oss-us-west-1.aliyuncs.com/web_images/firmware-update/NEEWER@2x.png" alt="">
    </div>
    <div class="logo2">
      <img src="http://usdb.oss-us-west-1.aliyuncs.com/web_images/firmware-update/NEEWER@2x.png" alt="">
    </div>
    <a-menu
      :default-selected-keys="selectedKeys"
      :open-keys="openKeys"
      @openChange="onOpenChange"
      mode="inline"
      :inline-collapsed="collapsed"
      :theme="'light'"
      style="width: 100%"
    >
      <template v-for="menu in menuList">
        <a-menu-item v-if="!menu.children" :key="menu.path" @click="onClickItem(menu)">
          <icon-font :type="menu.icon" />
          <span>{{ menu.title }}</span>
        </a-menu-item>
        <a-sub-menu v-else :key="menu.path">
          <div slot="title">
            <icon-font :type="menu.icon" />
            <span>{{ menu.title }}</span>
          </div>
          <a-menu-item
            v-for="subMenu in menu.children"
            :key="subMenu.path"
            @click="onClickItem(subMenu)"
          >
            {{ subMenu.title }}
          </a-menu-item>
        </a-sub-menu>
      </template>
    </a-menu>

  </div>
</template>
<script>
import { mapState } from "vuex";
import { Icon } from "ant-design-vue";

const IconFont = Icon.createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/font_2649856_6b125bc82dd.js"
});
export default {
  name: "Menu",
  components: {
    IconFont
  },
  props: {
    menuList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    defaultOpenKeys: {
      type: Array,
      default: () => {
        return [];
      }
    },
    defaultSelectedKeys: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      rootSubmenuKeys: [],
      selectedKeys: [],
      openKeys: []
    };
  },
  created() {
    // this.openKeys = [this.menuList?.[0]?.path];
    this.menuList.forEach((f, i) => {
      this.rootSubmenuKeys.push(`sub${i}`);
    });
    // console.log('menuList', this.menuList)
    this.selectedKeys = [this.$route.path.substr(1)];
    this.findOpenKeys();
  },
  computed: {
    ...mapState(["collapsed"])
  },
  methods: {
    onOpenChange(openKeys) {

      const last = openKeys.pop();
      this.openKeys = last ? [last] : [];
      // this.openKeys = openKeys;
      // console.log(this.openKeys);
    },
    requireImage(url) {
      return require("../../static/images/" + url);
    },
    onClickItem(sitem) {
      // console.log(sitem, "sitem");
      this.$router.push(`/${sitem.path}`);
    },
    findOpenKeys() {
      const menuList = this.menuList;
      const name = this.$route.name;
      for (let m of menuList) {
        if (name === m.path) {
          this.openKeys = [m.path];
          return;
        }
        if (m.children) {
          for (let c of m.children) {
            if (c.path === name) {
              this.openKeys = [m.path];
              return;
            }
          }
        }
      }
    }
  },
  watch: {
    $route: function() {
      this.selectedKeys = [this.$route.name];
      this.findOpenKeys();
    }
  }
};
</script>

<style lang="less" scoped>
.width180 {
  width: 180px;

  .logo {
    display: block;
  }

  .logo2 {
    display: none;
  }
}

.width80 {
  width: 80px;

  .logo {
    display: none;
  }

  .logo2 {
    display: block;
    text-align: center;
    padding: 15px;

    img {
      display: inline-block;
      width: 30px;
    }

  }
}

.menu_component {
  position: relative;
  min-height: 100%;
  background: #fff;
  overflow: hidden;

  .menu_component-wrap {
    width: 106%;
    height: 100%;
    overflow-y: scroll;
  }

  .logo {
    width: 100%;
    height: 60px;
    position: relative;
    text-align: center;
    line-height: 60px;
    //margin-bottom: 10px;
    img {
      height: 22px;
    }
  }

  .ant-menu-dark .ant-menu-inline.ant-menu-sub {
    box-shadow: none;
  }

  .ant-menu {
    background: #fff;
  }

  .ant-menu-submenu,
  .ant-menu-sub {
    background: #fff !important;
  }

  .ant-menu-item {
    background: #fff;
  }

  .ant-menu.ant-menu-dark .ant-menu-item-selected {
    background-color: #fff;
    color: #168DFF;
  }

  .ant-menu-item {
    margin-top: 0px;
    margin-bottom: 0px;
  }
}
</style>
